"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutPageArea = void 0;
var tslib_1 = require("tslib");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var list_1 = require("@devexpress/utils/lib/utils/list");
var LayoutPageArea = (function (_super) {
    tslib_1.__extends(LayoutPageArea, _super);
    function LayoutPageArea(subDocument) {
        var _this = _super.call(this, 0, 0, 0, 0) || this;
        _this.columns = [];
        _this.subDocument = subDocument;
        return _this;
    }
    LayoutPageArea.prototype.getEndPosition = function () {
        return this.pageOffset + list_1.ListUtils.last(this.columns).getEndPosition();
    };
    LayoutPageArea.prototype.getLastColumn = function () {
        return this.columns[this.columns.length - 1];
    };
    LayoutPageArea.prototype.deepCopy = function () {
        var obj = new LayoutPageArea(this.subDocument);
        obj.pageOffset = this.pageOffset;
        obj.columns = list_1.ListUtils.map(this.columns, function (col) { return col.deepCopy(); });
        obj.copyFrom(this);
        return obj;
    };
    return LayoutPageArea;
}(rectangle_1.Rectangle));
exports.LayoutPageArea = LayoutPageArea;
